// Ilustración pequeña y amigable para estados "todavía no hay nada aquí" en
// el panel de cada negocio (listas vacías, tarjetas del dashboard sin datos
// hoy, etc.). Mismo estilo "flat" redondeado que las ilustraciones del
// portal de inicio (frontend/src/components/landing/Ilustraciones.tsx), pero
// en un archivo aparte porque esta se usa dentro de la aplicación interna,
// no en el sitio público.
export function IlustracionVacia({ className = "h-20 w-20" }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 120" className={className} xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="60" cy="102" rx="40" ry="7" fill="#0f766e" opacity="0.08" />
      {/* tazón vacío */}
      <path d="M28 84 Q28 98 60 98 Q92 98 92 84 L88 84 Q88 92 60 92 Q32 92 32 84 Z" fill="#cbd5e1" />
      <ellipse cx="60" cy="83" rx="32" ry="7" fill="#e2e8f0" stroke="#cbd5e1" strokeWidth="1.5" />
      {/* perrito sentado, mirando curioso */}
      <g className="animar-flotar-lento" style={{ transformOrigin: "60px 60px" }}>
        <ellipse cx="60" cy="66" rx="22" ry="20" fill="#f5a95f" />
        <ellipse cx="42" cy="46" rx="8" ry="13" fill="#e18a3c" transform="rotate(-20 42 46)" />
        <ellipse cx="78" cy="46" rx="8" ry="13" fill="#e18a3c" transform="rotate(20 78 46)" />
        <circle cx="52" cy="60" r="4.2" fill="#334155" />
        <circle cx="68" cy="60" r="4.2" fill="#334155" />
        <circle cx="53.3" cy="58.5" r="1.3" fill="#fff" />
        <circle cx="69.3" cy="58.5" r="1.3" fill="#fff" />
        <ellipse cx="60" cy="70" rx="5" ry="4" fill="#334155" />
        <path d="M52 78 Q60 84 68 78" fill="none" stroke="#334155" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="46" cy="70" r="4.5" fill="#fca5a5" opacity="0.5" />
        <circle cx="74" cy="70" r="4.5" fill="#fca5a5" opacity="0.5" />
      </g>
    </svg>
  );
}
